import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useCallback, useEffect, useState } from "react";
// import Header from './components/Header';
// import QuestionInput from './components/QuestionInput';
// import QuestionInputV2 from './components/QuestionInputV2';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import NotFound from './components/NotFound';
import LoginForm from "./components/login/LoginForm";
import UnitechHBB from './components/UnitechHBB';

// Protected route wrapper
const ProtectedRoute = ({ isAuthenticated, children }) => {
  const location = useLocation();
  return isAuthenticated ? (
    children
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

// Login component
const Login = ({ onLogin }) => {
  const navigate = useNavigate();
  const location = useLocation();
  // Use the 'from' path from location.state, default to '/trynow' if not provided
  const from = location.state?.from?.pathname || "/";

  const handleLogin = useCallback(
    (token) => {
      onLogin(token);
      navigate(from, { replace: true });
    },
    [onLogin, navigate, from]
  );

  return <LoginForm onLogin={handleLogin} />;
};

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  // eslint-disable-next-line
  const [userRole, setUserRole] = useState(null);
  // eslint-disable-next-line
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleLogin = useCallback((token) => {
    localStorage.setItem("access_token", token);
    setIsAuthenticated(true);
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      setUserRole(payload.role);
      setIsAdmin(payload.role === "admin");
    } catch (err) {
      console.error("handleLogin: Token decode failed:", err);
      localStorage.removeItem("access_token");
      setIsAuthenticated(false);
      setUserRole(null);
      setIsAdmin(false);
    }
  }, []);

  const handleLogout = useCallback(() => {
    localStorage.removeItem("access_token");
    setIsAuthenticated(false);
    setUserRole(null);
    setIsAdmin(false);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        setIsAuthenticated(true);
        setUserRole(payload.role);
        setIsAdmin(payload.role === "admin");
      } catch (err) {
        console.error("useEffect: Token validation failed:", err);
        handleLogout();
      }
    }
    setLoading(false);
  }, [handleLogout]);

  if (loading) {
    return <div>Loading...</div>;
  }


  return (
    <div className="min-h-screen bg-gray-100">
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={true}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      {isAuthenticated ? (
        <>
          {/* <Header isAuthenticated={isAuthenticated} handleLogout={handleLogout} /> */}

          <Routes>
            <Route
              path="/"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <UnitechHBB isAuthenticated={isAuthenticated} handleLogout={handleLogout} />
                </ProtectedRoute>
              }
            />

            <Route
              path="*"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <NotFound />
                </ProtectedRoute>
              }
            />
          </Routes>
        </>
      ) : (
        <Routes>
          <Route path="/login" element={<Login onLogin={handleLogin} />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      )}
    </div>
  );
}

export default App;
